export default [
  {
    path: "/",
    text: "home",
  },
  {
    path: "/events",
    text: "events",
  },
  {
    path: "/blog",
    text: "blog",
  },
  {
    path: "/blogs",
    text: "blogs",
  },
  {
    path: "/contact",
    text: "contact",
  },
]
